<template>
  <sh-inliner class="file-media__item__header">
    <slot />
    &nbsp;
    <el-button
      v-if="!disabled"
      icon="el-icon-circle-plus"
      type="text"
    >Add</el-button>
  </sh-inliner>
</template>

<script>
export default {
  name: 'FileMediaItemHeader',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.file-media__item__header {
  .el-button--text {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/steps/FilesMedia/FileMediaItemHeader.vue